<template>
  <div class="select-campaign-view text-center">
    <div class="campaign-view-options">
      <div :class="['campaign-view', 'sms', { selected: smsInView, ['tab-error']: errors && !!errors.sms }]"
           @click="$emit('toggleSelectedView', 'sms')">
        text
      </div>
      <div :class="['campaign-view', 'email', { selected: emailInView, ['tab-error']: errors && !!errors.email }]"
           @click="$emit('toggleSelectedView', 'email')">
        email
      </div>
    </div>
    <span v-if="errors && !!errors.sendType" class="error-label">
        at least one message type has to be selected
    </span>
  </div>
</template>


<script>
  import { mapState } from 'vuex'

  export default {
    props: {
      emailInView: Boolean,
      smsInView: Boolean,
    },
    name: 'CampaignViewToggle',

    computed: {
      ...mapState({
        errors: state => state.errors,
      })
    },
  }
</script>